import algoliasearch from 'algoliasearch/lite';
import { useEffect, useState } from 'react';

export const searchClient = algoliasearch('Y2Y10MZ7JY', '1de4271379988b2cb3d797b07fca6805');

export function useAlgolia(product) {
  const [projects, setProjects] = useState([]);
  const index = searchClient.initIndex('projecthub');

  useEffect(() => {
    async function fetchPH() {
      try {
        const { hits } = await index.search(product);
        setProjects(hits);
      } catch (e) {
        throw new Error('cannot fetch Algolia');
      }
    }

    fetchPH();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return projects;
}
